import React from 'react';
import { Report, Type } from 'api/report/types';
import { TimesheetReport } from 'utils/report';
import { TimesheetDraftProvider } from './timesheet/TimesheetDraftContext';
import { IntervalDraftProvider } from './interval/IntervalDraftContext';

interface Props {
    report: Report | null;
    children: React.ReactNode;
    useSplitTextfields?: boolean;
}

export function ReportDraftProvider({
    report,
    children,
    useSplitTextfields,
}: Props) {
    switch (report?.template.type) {
        case Type.TIMESHEET:
            return (
                <TimesheetDraftProvider
                    report={report as TimesheetReport}
                    useSplitTextfields={useSplitTextfields}>
                    {children}
                </TimesheetDraftProvider>
            );
        case Type.INTERVAL:
            return (
                <IntervalDraftProvider report={report}>
                    {children}
                </IntervalDraftProvider>
            );
        default:
            return <>{children}</>;
    }
}
